import { render, staticRenderFns } from "./PieEChart.vue?vue&type=template&id=82a40e2a&scoped=true"
import script from "./PieEChart.vue?vue&type=script&lang=js"
export * from "./PieEChart.vue?vue&type=script&lang=js"
import style0 from "./PieEChart.vue?vue&type=style&index=0&id=82a40e2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a40e2a",
  null
  
)

export default component.exports